class JWT {
    constructor(token) {
        this.token = token
    }

    static getToken() {
        return window.localStorage.getItem('MDR_DASHBOARD_DA_TOKEN')
    }

    saveToken() {
        window.localStorage.setItem('MDR_DASHBOARD_DA_TOKEN', this.token)
    }

    static destroyToken() {
        window.localStorage.removeItem('MDR_DASHBOARD_DA_TOKEN')
    }
}

export default JWT